export function shouldDisplayConsoleDiagnostics(env = import.meta.env) {
  const mode = String(env?.MODE || '').toLowerCase();
  const viteEnv = String(env?.VITE_ENV || env?.VITE_ENVIRONMENT || '').toLowerCase();

  if (mode === 'production' || viteEnv === 'production') {
    return false;
  }

  return Boolean(env?.DEV) || env?.VITE_ENABLE_CONSOLE_ERROR_OVERLAY === 'true';
}
